import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { call, put } from "redux-saga/effects";
import { Upsells } from "../../../../../services/reddyApi/Upsells/Upsells";
import handleServerError from "../../../all/saga/handleServerError";
import setServerErrorDefault from "../../../all/saga/setServerErrorDefault";
import getNotifications from "../../../notifications/saga/getNotifications";
import { getStatisticsDashboard, getStatisticsFinance } from "../../../statistics/statistics.saga";
import { ChangeUpsellActivityPayload } from "../payload/ChangeUpsellActivity/ChangeUpsellActivityPayload";
import { changeUpsellActivityFetch, changeUpsellActivitySuccess, deleteAdditionalSuccess, getAdditionalFetch } from "../upsells.slice";

function* changeUpsellActivityWorker(action: PayloadAction<ChangeUpsellActivityPayload>) {
    const { vendorId, upsellId, active } = action.payload;

    try {
        const { status } = yield call(Upsells.changeUpsellActivity, { vendorId, upsellId, active });

        if (status === 200) {
            yield put(changeUpsellActivitySuccess({ upsellId, active }));

            if (active) {
                yield put(getAdditionalFetch({ vendorId, upsellId }));
            } else {
                // yield put(deleteAdditionalSuccess({ upsellId }));
            }

            yield getStatisticsDashboard({ vendorId });

            yield getStatisticsFinance({ vendorId });

            yield getNotifications(vendorId);

            yield setServerErrorDefault();
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const actionCreator = () => changeUpsellActivityFetch(action.payload);

            yield handleServerError(error, actionCreator);
        }
    }
}

export default changeUpsellActivityWorker;